import script from "./OrthoNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./OrthoNavBar.vue?vue&type=script&setup=true&lang=js"

import "./OrthoNavBar.vue?vue&type=style&index=0&id=0f1b8ace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1b8ace"]])

export default __exports__